var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMail = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M19.836 8.106V6.135L12 11.038 4.164 6.135v1.97L12 12.963zm0-3.942q.798 0 1.36.587.563.585.563 1.384v11.73q0 .798-.563 1.384a1.82 1.82 0 0 1-1.36.587H4.164q-.798 0-1.36-.587a1.93 1.93 0 0 1-.563-1.384V6.135q0-.798.563-1.384a1.82 1.82 0 0 1 1.36-.587z"
})));
export default SvgMail;